module.exports = __webpack_public_path__ + "static/media/user3.6e1b34ca.png";